import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({

    toolbar: {
        display: 'flex',
        gap: theme.spacing(1),
        padding: theme.spacing(1),
        position: 'relative',
        width: '100%',
        backgroundColor: '#fff',
        zIndex: '4',
        borderBottomLeftRadius: '30px',
        borderBottomRightRadius: '30px',
        paddingLeft: theme.spacing(3),
      },
    
      boxAbsolute: {
        position: 'fixed',
      },
    
      account: {
        right:theme.spacing(4),
        position:'absolute',
        padding: theme.spacing(0.3),
        '& svg':{
          fill: theme.palette.neutral.main,
          width:'30px',
          height:'30px',
        } , 
        backgroundColor: theme.palette.primary.main,
      },
    
      endSession: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignContent: 'center',
        marginBottom: theme.spacing(2),
      },
    
      endSessionButton: {
        borderRadius: '30px',
        backgroundColor: theme.palette.darkBlue.main,
      },
    
      linkIcon: {
        fill: theme.palette.darkGray.main,
        '& svg':{
          width: '30px',
          height:'30px',
        },
      },

      bottomNavigation: {
        padding: theme.spacing(0.4),
        '& svg':{
            fill: theme.palette.darkGray.main,
            width:'40px',
            height:'40px',
        },
        '& .Mui-selected>svg': {
            borderRadius: '30px',
            fill:theme.palette.primary.main,
          },
      }

}));